import { render } from "./modal-edit-profile-page.html?vue&type=template&id=93311a9a&ts=true"
import script from "./modal-edit-profile-page.vue?vue&type=script&lang=ts"
export * from "./modal-edit-profile-page.vue?vue&type=script&lang=ts"

import "./modal-edit-profile-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__